/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterTemplateEventListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterTemplateEventFactory,
		UserSalesFilterTemplateEventListDtoSearchFactory,
		UserSalesFilterTemplateEventViewDtoFactory
	) {
		$scope.salesFilterTemplateEventList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterTemplateEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterTemplateEvent);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-salesfiltertemplateevent.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getSalesFilterTemplateEventList = function() {
			UserSalesFilterTemplateEventListDtoSearchFactory.query(
				{
					salesFilterId: angular.isDefined($scope.salesFilterId) ? $scope.salesFilterId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterTemplateEventList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterTemplateEventList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
